/* import external modules */
import React, { useState, useEffect } from 'react'
import moment from 'moment'
import PropTypes from 'prop-types'
import { useDispatch, useSelector } from 'react-redux'

/* import internal modules */
import CardInfo from '../../Common/CardInfo'
import Img from '../../Common/Img'
import CampaignRejectContent from '../CampaignRejectContent'

import { dateFormat } from './../../../constants/formats'
import { AdvertisingType } from '../../../constants/advertisingType'
import { MaterialStatusCode, MaterialStatusCondolence, CampaigntTypeStatus } from '../../../constants/status'

import { Container, CardWrapper, State, Link, ColActions, ColImg } from './styles'

import 'moment/locale/es' // without this line it didn't work

import ModalReport from '../ModalReport'
// import TypeProductContent from "./typeProductContent";

import ActionsAdvertise from '../AdvertiseItem/ActionsAdvertise'
import { Col, Row } from 'styled-bootstrap-grid'
import P from '../../Common/P'
import { setLoading } from '../../../redux/actions/ui/ui'
import { CampaingError } from '../CampaignReject/styles'
import Alert from '../../Common/Alert'
import ModalUploadMaterialReject from '../ModalUploadMaterialReject'
import DivUploadObt from '../../Common/DivUploadObt'
import ImgPreviewObt from '../../Common/ImgPreviewObt'
import ModalUploadMaterialRejectMessage from '../ModalUploadMaterialReject/ModalUploadMaterialRejectMessage'

moment.locale('es')
moment.suppressDeprecationWarnings = true



const MessageItem = ({
  numAdvertise,
  statusCode,
  imgAd,
  adId,
  format,
  device,
  advertisingTypeId,
  initialDate,
  endDate,
  urlReport,
  review,
  imageTemplate,
  limitDate,
  typeAd,
  reportDataStudio,
  reportType,
  campaignName,
  campaignId,
  advertisements,
  nameFormat,
  message,
  dateStatus,
  urlSmart
}) => {
  const [open, setOpen] = useState(false)
  const [isOpen, setIsOpen] = useState(false)
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener('resize', handleResize);
    handleResize(); // Set initial width

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  let statusAdvertise =
    statusCode === MaterialStatusCode.Rejected
      ? MaterialStatusCondolence.Rejected
      : statusCode === MaterialStatusCode.Approved
        ? MaterialStatusCondolence.Approved
        : MaterialStatusCondolence.Pending


  const start = moment()
  const finalDate = moment(endDate, dateFormat)




  //Difference in number of days
  const diff = start.diff(finalDate, 'days')
  const nextDayFinalDate = diff > 0

  const startDateForLink = moment(initialDate, dateFormat).startOf('day');
  const endDateForLink = moment(initialDate, dateFormat).add(7, 'days').endOf('day');
  const currentDate = moment();
  const showMessageDigitalLink = currentDate.isBetween(startDateForLink, endDateForLink, null, '[]');

  const advertisingData = {
    numAdvertise,
    format,
    initialDate,
    endDate,
    reportDataStudio,
    campaignName,
    campaignId,
    device
  }



  const handleIsOpen = () => setIsOpen(true)
  const handleIsClose = () => setIsOpen(false)
  const handleClose = () => setOpen(false)
  const [messageAlert, setMessageAlert] = useState({
    message: '',
    state: '',
    show: false,
  })
  const [imageUrl, setImageUrl] = useState('')
  const [imageToUpload, setImageToUpload] = useState('')
  const dispatch = useDispatch()
  const [openModal, setOpenModal] = useState(false)
  const [imageFormat, setImageFormat] = useState({ width: 141, height: 160 })

  const handleImage = (image, message, status) => {
    switch (status) {
      case true:
        setImageToUpload(image)
        const createUrl = URL.createObjectURL(image)

        let reader = new FileReader()
        reader.readAsDataURL(image)
        reader.onload = () => {
          setOpenModal(true)
          dispatch(setLoading(false))
        }
        reader.onerror = function (error) {
          console.error('Error: ', error)
        }
        setImageUrl(createUrl)
        setMessageAlert({
          ...messageAlert,
          show: false,
          message: '',
          state: '',
        })
        break

      case false:
        setImageUrl('')
        setMessageAlert({
          ...messageAlert,
          message: message,
          state: 'error',
          show: true,
        })
        dispatch(setLoading(false))
        break

      case 'loading':
        setMessageAlert({
          ...messageAlert,
          message: '',
          state: '',
          show: false,
        })
        dispatch(setLoading(true))
        break

      default:
        setImageUrl('')
        setOpenModal(false)
        dispatch(setLoading(false))
        setMessageAlert({
          ...messageAlert,
          message: '',
          state: '',
          show: false,
        })
        break
    }
  }

  const selectedTab = useSelector((state) => state.campaigns.selectedTab);

  let uploadMessageText;
  if (statusCode === MaterialStatusCode.Rejected) {
    let displayDate = limitDate;
    if (limitDate) {

      const parsedDate = moment(limitDate, 'DD/MMM/YYYY', 'es');
      if (parsedDate.isValid()) {
        displayDate = parsedDate.format('DD/MM/YYYY');
      }
    }

    uploadMessageText = `Por favor carga una nueva la imagen antes del ${displayDate}.`;

    if (message && typeof message.priceAditional === 'number' && message.createdAt) {
      const purchaseDate = moment(message.createdAt);
      if (purchaseDate.isValid()) {
        const dayOfWeek = purchaseDate.day();
        const isNacional = message.priceAditional > 0;
        let timeLimit = '';

        if (isNacional) {
          timeLimit = '12:00 PM';
        } else {
          if (dayOfWeek >= 0 && dayOfWeek <= 5) {
            timeLimit = '5:30 PM';
          } else if (dayOfWeek === 6) {
            timeLimit = '3:00 PM';
          }
        }

        if (timeLimit) {
          uploadMessageText =
            <>Por favor carga una nueva imagen antes del <strong>{displayDate} - {timeLimit}. </strong> </>

        }
      }
    }
  }

  return (
    <Container>
      {windowWidth <= 768 && statusCode === MaterialStatusCode.Rejected &&
        <ColImg>
          <P>
            Imagen
          </P>
          <State className={statusAdvertise}>
            {statusAdvertise}
          </State> <br></br>
          <P font="14px/18px 'DMSans-Regular'" color="#606466" mt="5px" className='review'>
            Motivo: {review}
          </P>

          <P font="14px/18px 'DMSans-Bold'" color="#606466" mb="10px" className='infoText'>
            {uploadMessageText}
          </P>
          <div className='imgUploadMobile'>
          <DivUploadObt
            dimensions={imageFormat}
            advertisingId={adId}
            isObt={2}
            isMobile={false}
            handleImage={handleImage}
            style={{paddin:'10px 0px 10px 100px'}}
          />
          </div>
          <P font="14px/16px 'DMSans-Regular'" color="#8f8f8f" mt="10px" className='review'>
            PNG,JPG, JPGE con peso máximo de 100MB.
          </P>
          {messageAlert.show && (
            <CampaingError>
              <Alert title={messageAlert.message} state={messageAlert.state} />
            </CampaingError>
          )}
          {openModal && (
            <ModalUploadMaterialRejectMessage
              open={openModal}
              onClose={() => {
                setOpenModal(false)
              }}
              imageTemplate={imageTemplate}
              imageUrlUpload={imageUrl}
              imageToUpload={imageToUpload}
              device={device}
              format={format}
              adId={adId}
              advertisingTypeId={advertisingTypeId}
              nameFormat={nameFormat}
              className='imgReject'
            />
          )}
        </ColImg>}

      <CardWrapper imgPriceAditional={message?.imgPriceAditional ? message?.imgPriceAditional : 0} statusCode={statusCode} statusAdvertise={statusAdvertise}>
        {windowWidth > 768 && <Row className='row-image'>
          {message?.imgPriceAditional > 0 && statusCode !== MaterialStatusCode.Rejected && (
            <Link href={imgAd} target="_blank" >
              <Img src={imgAd} className="imgCtr"/>
              
            </Link>
          )}


          {
            <CardInfo
              className="Img"
              title="Imagen"
              text={message?.imgPriceAditional > 0 ? null : 'Sin Imagen'}
              style={{ marginLeft: message?.imgPriceAditional === 0 && windowWidth <= 768 ? '15px' : '5px' }}
            >
              {message?.imgPriceAditional > 0 ?
                <>
                  <State className={statusAdvertise}>
                    {statusAdvertise}
                  </State> <br></br>
                  {statusCode === MaterialStatusCode.Rejected && (

                    <P font="14px/18px 'DMSans-Regular'" color="#606466" className='review'>
                      Motivo: {review}
                    </P>

                  )}

                </> :
                null
              }
            </CardInfo>}
        </Row>}
        {
          windowWidth <= 768 && statusCode !== MaterialStatusCode.Rejected &&
          <Row>
            {message?.imgPriceAditional > 0 && statusCode !== MaterialStatusCode.Rejected && (
              <Link href={imgAd} target="_blank" >
                <Img src={imgAd} className="imgCtr"/>
              </Link>
            )}

            {statusCode !== MaterialStatusCode.Rejected &&
              <CardInfo
                className="Img"
                title="Imagen"
                text={message?.imgPriceAditional > 0 ? null : 'Sin Imagen'}
                style={{ marginLeft: message?.imgPriceAditional === 0 && windowWidth <= 768 ? '15px' : '5px' }}
              >
                {message?.imgPriceAditional > 0 &&
                  <>
                    <State className={statusAdvertise}>
                      {statusAdvertise}
                    </State> <br></br>
                    {statusCode === MaterialStatusCode.Rejected && (

                      <P font="14px/18px 'DMSans-Regular'" color="#606466" mt="5px" className='review'>
                        Motivo: {review}
                      </P>

                    )}

                  </>
                }
              </CardInfo>}
          </Row>
        }


        {statusCode !== MaterialStatusCode.Rejected && windowWidth <= 768 && <div></div>}
        <CardInfo
          className="DateStart"
          title="Digital fecha inicio"
          text={initialDate} />
        <CardInfo
          className="DateEnd"
          title="Digital fecha fin"
          text={endDate} />



        {
          (dateStatus === 1 || dateStatus === 2) && statusCode !== MaterialStatusCode.Rejected && windowWidth >= 768 &&
          <ColActions className="actions">
          <div className='actionMaterial'>
          { (urlReport || showMessageDigitalLink) && (<CardInfo
              className="Report"
              title="Acciones">
            </CardInfo>
          )}         
            { urlReport && (<ActionsAdvertise onClick={() => setOpen(true)}
              typeAd={typeAd}
              urlReport={urlReport}
              urlSmart={urlSmart}
              reportType={reportType}
            />)}
            

            {showMessageDigitalLink && <a target="_blank" className='messageDigital' href='https://www.eltiempo.com/condolencias'> Ver mensaje digital</a>}
          </div>
          </ColActions>

        }


        {
          statusCode === MaterialStatusCode.Rejected && windowWidth > 768 &&
          <Row className='row-upload' >
            <ImgPreviewObt imgUrl={imgAd} />
            <Col className='col-upload'>

              <CardInfo
                className="Report"
                title="Acciones">
              </CardInfo>

              <DivUploadObt
                dimensions={imageFormat}
                campaignId={campaignId}
                advertisingId={adId}
                isObt={2}
                isMobile={false}
                handleImage={handleImage}
              />
              <P font="14px/16px 'DMSans-Regular'" color="#8f8f8f" mt="10px" className='review'>
                Dimensiones: 141x160px <br></br>
                PNG,JPG, JPGE con peso máximo de 100MB.
              </P>
            </Col>



            {messageAlert.show && (
              <CampaingError>
                <Alert title={messageAlert.message} state={messageAlert.state} />
              </CampaingError>
            )}
            {openModal && (
              <ModalUploadMaterialRejectMessage
                open={openModal}
                onClose={() => {
                  setOpenModal(false)
                }}
                imageTemplate={imageTemplate}
                imageUrlUpload={imageUrl}
                imageToUpload={imageToUpload}
                device={device}
                format={format}
                adId={adId}
                advertisingTypeId={advertisingTypeId}
                nameFormat={nameFormat}
              />
            )}

          </Row>

        }


        {statusCode === MaterialStatusCode.Rejected && windowWidth >= 768 && (
          <P font="14px/18px 'DMSans-Regular'" color="#606466">
          </P>)}
        {/* {statusCode === MaterialStatusCode.Rejected && windowWidth >= 768 && (
          <P font="14px/18px 'DMSans-Bold'" color="#606466">
            {uploadMessageText}
          </P>)} */}
      </CardWrapper>
      {statusCode === MaterialStatusCode.Rejected && windowWidth >= 768 && (
        <Row>
          <div style={{ width: '280px' }}> </div>
          <P font="14px/18px 'DMSans-Medium'" color="#606466" className="upload-message-text">
            {uploadMessageText}
          </P>
        </Row>
      )}
      {
        (dateStatus === 1 ) && statusCode !== MaterialStatusCode.Rejected && windowWidth <= 768 && urlReport && (
        <ActionsAdvertise onClick={() => setOpen(true)}
              typeAd={typeAd}
              urlReport={urlReport}
              urlSmart={urlSmart}
              reportType={reportType}
            />
      )}
      
      {
        
        (dateStatus === 1 ) && statusCode !== MaterialStatusCode.Rejected && windowWidth <= 768 && showMessageDigitalLink &&
        <a className='messageDigital' target="_blank" href='https://www.eltiempo.com/condolencias'> Ver mensaje digital</a>

      }
      {/* {statusCode === MaterialStatusCode.Rejected &&
        typeAd === AdvertisingType.Display && (
          <CampaignReject
            num={`${numCampaign}-${numAdvertise}`}
            review={review}
            width={160}
            height={141}
            weight={100000}
            device={device}
            date={limitDate}
            format={format?.name}
            imageTemplate={imageTemplate}
            adId={adId}
            advertisingTypeId={advertisingTypeId}
            nameFormat={nameFormat}
          />
        )} */}
      {statusCode === MaterialStatusCode.Rejected &&
        typeAd === AdvertisingType.Content && (
          <CampaignRejectContent review={review} date={limitDate} />
        )}
      {open && <ModalReport onClose={handleClose} open={open} data={advertisingData} />}
    </Container>
  )
}

MessageItem.propTypes = {
  numAdvertise: PropTypes.number,
  statusCode: PropTypes.number,
  imgAd: PropTypes.string,
  format: PropTypes.object,
  device: PropTypes.string,
  typeSegment: PropTypes.number,
  numCampaign: PropTypes.string,
  infoSegmentPortal: PropTypes.array,
  infoSegmentAudience: PropTypes.array,
  impressions: PropTypes.string,
  url: PropTypes.string,
  initialDate: PropTypes.string,
  endDate: PropTypes.string,
  urlReport: PropTypes.string,
  review: PropTypes.string,
  imageTemplate: PropTypes.string,
  limitDate: PropTypes.string,
  adContent: PropTypes.object,
  typeAd: PropTypes.string,
  urlSmart: PropTypes.string,
  reportDataStudio: PropTypes.string,
  campaignName: PropTypes.string,
  campaignId: PropTypes.number,
  reportType: PropTypes.number
}

export default MessageItem
